var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-body"},[_c(_vm.modalContentName,{ref:"form",tag:"component",attrs:{"modalData":_vm.modalData,"changesAccepted":_vm.changesAccepted},on:{"allowChanges":_vm.allowChanges}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }